import { css } from '@emotion/react';
import styled from '@emotion/styled/macro';

type NameWrapperType = {
  bold?: boolean;
};

export const NumberWrapper = styled.div<NameWrapperType>`
  font: normal normal 0.875rem/1.5rem ${({ theme }) => theme.font.gotham};
  color: ${({ theme }) => theme.color.black};
  ${({ bold }) => css`
    ${bold &&
    css`
      font-weight: bold;
    `}
  `}
`;
